module.exports = __webpack_public_path__ + "static/media/projectdetails.4d6d02c5.PNG";